jQuery(document).ready(function($) {
    $(document).on('focus mouseover', 'input.datetimepicker:not(.js-has-datetimepicker)', function() {
        var $this = $(this);
        var options = {
            format: "Y-m-d H:i:00",
            formatDate: "Y-m-d",
            todayButton: true,
            scrollInput: false
        };

        if ($this.hasClass('start-today')) {
            options['minDate'] = Date.today();
        } else if ($this.hasClass('start-yesterday')) {
            options['minDate'] = Date.parse('yesterday');
        }

        if ($this.hasClass('disable-last-day-of-month')) {
            options['disabledDates'] = [Date.today().moveToLastDayOfMonth().toString('yyyy-MM-dd')];
        }

        $this.attr('autocomplete', 'off')
            .addClass('js-has-datetimepicker')
            .datetimepicker(options);
    });

    $(document).on('focus mouseover', 'input.datepicker:not(.js-has-datepicker)', function() {
        var $this = $(this);
        var options = {
            timepicker: false,
            format: "Y-m-d",
            formatDate: "Y-m-d",
            todayButton: true,
            scrollInput: false
        };

        if ($this.data('format')) {
            options['format'] = $this.data('format');
        }

        if ($this.hasClass('start-today')) {
            options['minDate'] = Date.today();
        } else if ($this.hasClass('start-yesterday')) {
            options['minDate'] = Date.parse('yesterday');
        }

        if ($this.hasClass('disable-last-day-of-month')) {
            options['disabledDates'] = [Date.today().moveToLastDayOfMonth().toString('yyyy-MM-dd')];
        }

        $this.attr('autocomplete', 'off')
            .addClass('js-has-datepicker')
            .datetimepicker(options);
    });

    $(document).on('focus mouseover', 'input.timepicker:not(.js-has-timepicker)', function() {
        $(this).attr('autocomplete', 'off')
            .addClass('js-has-timepicker')
            .datetimepicker({
                datepicker: false,
                scrollInput: false,
                format: "H:i:00",
                step: 10
            });
    });

    $(document).on('focus mouseover', 'input.timepicker-wmask:not(.js-has-timepicker-wmask)', function() {
        $(this).attr('autocomplete', 'off')
            .addClass('js-has-timepicker-wmask')
            .datetimepicker({
                datepicker: false,
                timepicker: false,
                scrollInput: false,
                format: "H:i:s",
                mask:true,
            });
    });

    $(document).on('mouseover', 'form[data-validate="validate"]:not(.js-validate)', function() {
        $(this)
            .addClass('js-validate')
            .validate({
                errorElement: 'span',
                errorPlacement: function(error, element) {
                    var $formGroup = element.closest('.form-group');
                    var $inputGroup = element.closest('.input-group');

                    if ($formGroup.length > 0) {
                        $formGroup.append(error);
                    } else if ($inputGroup.length > 0) {
                        $inputGroup.after(error);
                    } else {
                        error.insertAfter(element);
                    }
                }
            });
    });

    $(document).on('mouseover', '[data-toggle="tooltip"]:not(.has-tooltip), [data-provide="tooltip"]:not(.has-tooltip)', function(e) {
        $(this).tooltip()
            .tooltip('show')
            .addClass('has-tooltip');
    });

    $(document).on('mouseover', '[data-toggle="popover"]:not(.has-popover)', function(e) {
        $(this).popover({ trigger: 'hover' })
            .popover('show')
            .addClass('has-popover');
    });

    // Similar to above but respect data attributes for when the popup should show rather than force mouseover
    $(document).on('focus mouseover', '[data-toggle="popover-configurable"]:not(.has-popover)', function(e) {
        let el = $(this);
        el.popover(el.data());
        el.addClass('has-popover');
    });

    $(document).on('mouseover', 'input[data-check-all]:not(.has-check-all)', function(e) {
        var $input = $(this);
        $input.addClass('has-check-all');

        $input.on('change', function(e) {
            $($input.data('checkAll')).attr('checked', this.checked).trigger('change');
        });

        $(document).on('change', $input.data('checkAll'), function(e) {
            if ($($input.data('checkAll')).length == $($input.data('checkAll') + ':checked').length) {
                $input.attr('checked', true);
            } else {
                $input.attr('checked', false);
            }
        });
    });

    // Manually trigger mouseover for custom checkboxes
    $(document).one('mouseover', '.custom-checkbox:has(input[data-check-all])', function(e) {
        $(this).find('input[data-check-all]:not(.has-check-all)').trigger('mouseover');
    });

    $(document).on('mouseover', '[data-clipboard-action="copy"]:not(.has-clipboard-copy)', function(e) {
        var $this = $(this);
        $this.addClass('has-clipboard-copy');

        $this.tooltip({
            title: 'Click to copy to clipboard',
            placement: 'bottom',
        });

        $this.tooltip('show');

        var clipboard = new ClipboardJS(this);

        clipboard.on('success', function(e) {
            $this.attr('data-original-title', 'Copied to clipboard').tooltip('show');

            setTimeout(function () {
                $this.attr('data-original-title', 'Click to copy to clipboard').tooltip('hide');
            }, 500);

            e.clearSelection();
        });
    });

    $(document).on('click', 'button[href]', function(e) {
        window.location.href = $(this).attr('href');
    });

    $(document).on('click', 'data-confirm', function(e) {
        if (! confirm($(this).data('confirm'))) {
            e.preventDefault();
        }
    });

    $(document).on('click', '[data-toggle="toggle"]', function(e) {
        e.preventDefault();

        var target = $(this).data('target');

        $(target).toggleClass('d-none').trigger('toggle');
    });

    $(document).on('change', 'tr [type="checkbox"]', function (e) {
        var $this = $(this);
        $this.closest('tr').toggleClass('selected', this.checked);
    });

    $(document).on('change', 'tr [type="radio"]', function (e) {
        var $this = $(this);
        $this.closest('table').find('tbody tr').removeClass('selected');
        $this.closest('tr').addClass('selected');
    });

    $(document).on('keyup', '.auto-leading-zero', function (e) {
        if (this.value != '' && this.value.charAt(0) != '0') {
            this.value = '0' + this.value;
        }
    });

    $(document).on('keyup', '[data-counter="true"]', function() {
        var $this = $(this);
        var $counter = $this.closest('.form-group').find('.counter');
        var maxLength = $this.attr('maxlength');
        var currentLength = $this.val().length;

        $counter.html(maxLength - currentLength + '/' + maxLength);
    });

    // Prevent multiple form submission
    $(document).on('submit', 'form.prevent_multiple_submit', function(e) {
        var $form = $(this);

        if ( $form.valid() ) {
            $form.addClass('pjax loading');
        }
    });

    $(document).on('submit', 'form.prevent-duplicate-submission', function(e) {
        var $form = $(this);

        var skipValidation = $form.attr('novalidate') !== undefined;

        if (skipValidation || $form.valid()) {
            $form.addClass('placeholder-glow');
            $form.find(':submit')
                .addClass('placeholder')
                .attr('type', 'button');
        }
    });

    // Fix reset for tagsinput
    $('form').on('reset', function(event) {
        $(this).find('[data-role="tagsinput"]').each(function(i, input) {
            $(input).tagsinput('removeAll');
        });

        // Clear select2 dropdowns
        $(this).find('.select2-hidden-accessible').each(function(i, input) {
            initializeSelect2Inputs();

            $(input).val(null).trigger('change');
        });
    });

    // Modals with url
    $(document).on('click', '[data-toggle="modal"][data-target]:not([href^="#"])', function (e) {
        $($(this).data("target") + ' .modal-body').load(this.href);
    });

    $(document).on('click', '.input-group-show-text', function (e) {
        e.preventDefault();

        var $this = $(this);

        var $input = $this.closest('.form-group').find('input');
        $input.attr('type', $input.attr('type') == 'password' ? 'text' : 'password');

        $this.html($this.html() == 'Show' ? 'Hide' : 'Show');
    });

    // Tabs with url
    $(document).on('show.bs.tab', '[data-toggle="tab"][data-url]:not(.initialized)', function (e) {
        var $this = $(e.target).addClass('initialized');
        var $container = $($this.data('target'));

        $container.load($this.data('url'));
    });

    $.fn.dataTableExt.sErrMode = 'throw';

    $(document).on('select2:opening', '.select2-hidden-accessible', function(e) {
        initializeSelect2Inputs();
    });
});

function whenAvailable(name, available, notAvailable) {
    var interval = 500; // ms

    if (window[name]) {
        available(window[name]);
    } else {
        if (typeof notAvailable == 'function') {
            notAvailable(name);
        }

        setTimeout(function() {
            whenAvailable(name, available, notAvailable);
        }, interval);
    }
}

function initializeSelect2Inputs() {
    // Single select2 inputs need the first option in the dropdown to have an empty value in order for them to clear successfully
    // otherwise "clear" or "reset" actions will set them back to whatever the first option the user chose was
    // https://select2.org/placeholders#single-select-placeholders
    $('select.select2-hidden-accessible[multiple!=multiple]').each(function(i, input) {
        if (input.firstElementChild && !input.firstElementChild.value) {
            return;
        }

        $(input).prepend($('<option value=""></option>'));
    });
}
